"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireWildcard(require("react"));

var _reactTransitionGroup = require("react-transition-group");

var _createTransitionContext = require("../context/createTransitionContext");

var _delayTransitionRender = _interopRequireDefault(require("./delayTransitionRender"));

var _returnTransitionState = require("../utils/returnTransitionState");

var _router = require("@reach/router");

var _secondsMs = require("../utils/secondsMs");

var _onEnter2 = require("../functions/onEnter");

var _onExit2 = require("../functions/onExit");

var _Layout = require("./Layout");

var _pageMinHeight = _interopRequireDefault(require("../functions/pageMinHeight"));

var _jsxFileName = "/Users/tylerbarnes/Web/gatsby-plugin-transition-link/src/components/TransitionHandler.js";
var DelayedTransition = (0, _delayTransitionRender.default)(_reactTransitionGroup.Transition);

var TransitionHandler =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(TransitionHandler, _Component);

  function TransitionHandler(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.wrapper = _react.default.createRef();
    _this.updatePageMinHeight = _this.updatePageMinHeight.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  var _proto = TransitionHandler.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updatePageMinHeight();
    window.addEventListener("resize", this.updatePageMinHeight);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener("resize", this.updatePageMinHeight);
  };

  _proto.updatePageMinHeight = function updatePageMinHeight() {
    var _this2 = this;

    setTimeout(function () {
      return (0, _pageMinHeight.default)({
        node: _this2.wrapper
      });
    }, 1);
  };

  _proto.render = function render() {
    var _this3 = this;

    var props = this.props;
    var children = props.children;
    return _react.default.createElement(_createTransitionContext.Consumer, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 44
      },
      __self: this
    }, function (_ref) {
      var exitDelay = _ref.exitDelay,
          exitLength = _ref.exitLength,
          exitState = _ref.exitState,
          entryDelay = _ref.entryDelay,
          entryLength = _ref.entryLength,
          entryState = _ref.entryState,
          entryTrigger = _ref.entryTrigger,
          entryProps = _ref.entryProps,
          exitTrigger = _ref.exitTrigger,
          exitProps = _ref.exitProps,
          transitionIdHistory = _ref.transitionIdHistory,
          inTransition = _ref.inTransition,
          updateContext = _ref.updateContext,
          e = _ref.e;
      return _react.default.createElement(_router.Location, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 62
        },
        __self: this
      }, function (_ref2) {
        var _ref2$location = _ref2.location,
            action = _ref2$location.action,
            pathname = _ref2$location.pathname;
        return _react.default.createElement(_Layout.LayoutComponent, (0, _extends2.default)({}, props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 64
          },
          __self: this
        }), _react.default.createElement(_reactTransitionGroup.TransitionGroup, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 65
          },
          __self: this
        }, _react.default.createElement(DelayedTransition, {
          key: pathname // we're using seconds but transitiongroup uses ms
          ,
          delay: (0, _secondsMs.getMs)(entryDelay),
          timeout: {
            enter: (0, _secondsMs.getMs)(entryLength),
            exit: (0, _secondsMs.getMs)(exitLength)
          },
          onEnter: function onEnter(node) {
            return !!node && (0, _onEnter2.onEnter)({
              node: node,
              action: action,
              inTransition: inTransition,
              entryTrigger: entryTrigger,
              entryProps: entryProps,
              exitProps: exitProps,
              pathname: pathname,
              updateContext: updateContext,
              pageMinHeight: _pageMinHeight.default,
              e: e
            });
          },
          onExit: function onExit(node) {
            return !!node && (0, _onExit2.onExit)({
              node: node,
              inTransition: inTransition,
              exitTrigger: exitTrigger,
              entryProps: entryProps,
              exitProps: exitProps,
              e: e
            });
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 66
          },
          __self: this
        }, function (transitionStatus) {
          var transitionState = (0, _returnTransitionState.returnTransitionState)({
            inTransition: inTransition,
            location: props.location,
            transitionIdHistory: transitionIdHistory,
            transitionStatus: transitionStatus,
            entry: {
              state: entryState,
              delay: entryDelay,
              length: entryLength
            },
            exit: {
              state: exitState,
              delay: exitDelay,
              length: exitLength
            }
          });
          var exitZindex = exitProps.zIndex || 0;
          var entryZindex = entryProps.zIndex || 1;

          var childWithTransitionState = _react.default.Children.map(children, function (child) {
            return _react.default.cloneElement(child, (0, _extends2.default)({}, transitionState));
          });

          return _react.default.createElement("div", {
            ref: function ref(n) {
              return _this3.wrapper = n;
            },
            className: "tl-wrapper",
            style: {
              position: "absolute",
              width: "100%",
              zIndex: transitionStatus === "entering" || transitionStatus === "entered" ? entryZindex : exitZindex
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 131
            },
            __self: this
          }, _react.default.createElement(_createTransitionContext.PublicProvider, {
            value: (0, _extends2.default)({}, transitionState),
            __source: {
              fileName: _jsxFileName,
              lineNumber: 144
            },
            __self: this
          }, childWithTransitionState));
        })));
      });
    });
  };

  return TransitionHandler;
}(_react.Component);

exports.default = TransitionHandler;